import React from 'react';
import Icon from '../../../components/AppIcon';

const ChallengeStats = ({ stats }) => {
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(amount);
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US')?.format(num);
  };

  const statItems = [
    {
      icon: 'DollarSign',
      label: 'Total Raised',
      value: formatAmount(stats?.totalRaised),
      change: `+${stats?.raisedGrowth}%`,
      changeType: 'positive'
    },
    {
      icon: 'Users',
      label: 'Active Participants',
      value: formatNumber(stats?.activeParticipants),
      change: `+${stats?.participantGrowth}`,
      changeType: 'positive'
    },
    {
      icon: 'Trophy',
      label: 'Challenges Completed',
      value: formatNumber(stats?.completedChallenges),
      change: `${stats?.completionRate}%`,
      changeType: 'neutral'
    },
    {
      icon: 'Target',
      label: 'Success Rate',
      value: `${stats?.successRate}%`,
      change: `+${stats?.successGrowth}%`,
      changeType: 'positive'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statItems?.map((item, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-gentle">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
              item?.changeType === 'positive' ?'bg-success/10 text-success' 
                : item?.changeType === 'negative' ?'bg-error/10 text-error' :'bg-primary/10 text-primary'
            }`}>
              <Icon name={item?.icon} size={24} />
            </div>
            <div className={`text-xs font-medium px-2 py-1 rounded-full ${
              item?.changeType === 'positive' ?'bg-success/10 text-success'
                : item?.changeType === 'negative' ?'bg-error/10 text-error' :'bg-muted text-muted-foreground'
            }`}>
              {item?.change}
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold text-card-foreground mb-1">
              {item?.value}
            </p>
            <p className="text-sm text-muted-foreground">
              {item?.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChallengeStats;